import React from 'react';
import classNames from 'classnames';

import styles from './PackageName.module.scss';

const {
  'package-name': packageNameClass,
  'decedent-name': decedentNameClass,
  'short-name': shortNameClass,
  'medium-name': mediumNameClass,
  'long-name': longNameClass,
  'really-long-name': reallyLongNameClass
} = styles;

const PackageName = ({ name = 'Complete Funeral', decedentName = '', page = '' }) => {
  const decedentNameLength = decedentName.length;
  const decedentNameClasses = classNames(decedentNameClass, {
    [shortNameClass]: decedentNameLength <= 10,
    [mediumNameClass]: decedentNameLength > 10 && decedentNameLength < 18,
    [longNameClass]: decedentNameLength >= 18,
    [reallyLongNameClass]: decedentNameLength > 25
  });

  return (
    <h1 className={packageNameClass}>
      {decedentName ? (
        <span className={decedentNameClasses}>{decedentName}'s</span>
      ) : (
        <span>THE</span>
      )}
      {name}
      <span>{page === 'price' ? '' : 'PACKAGE'}</span>
    </h1>
  );
};

export default PackageName;
